export default "__VITE_ASSET__bc6b1e15__"